/**
 * Social analytics blocks. Not part of DEFAULT_ANALYTICS_SECTIONS
 * so they are not persisted empty for clubs without the betas.
 */

export const SOCIAL_ANALYTICS_SECTIONS = [
    { id: 'socialNemesis', name: 'Nemesis', betaId: 'social_nemesis', visible: true, expanded: false },
    { id: 'socialKingmaker', name: 'Kingmaker', betaId: 'social_kingmaker', visible: true, expanded: false },
    { id: 'socialCloser', name: 'Closer', betaId: 'social_closer', visible: true, expanded: false },
    { id: 'socialChoker', name: 'Choker', betaId: 'social_choker', visible: true, expanded: false },
    { id: 'socialGiantSlayer', name: 'Giant Slayer', betaId: 'social_giant_slayer', visible: true, expanded: false },
    { id: 'socialSpecialist', name: 'Specialist', betaId: 'social_specialist', visible: true, expanded: false },
    { id: 'socialRivalry', name: 'Rivalry', betaId: 'social_rivalry', visible: true, expanded: false },
    { id: 'socialSkill', name: 'Skill rating', betaId: 'social_skill', visible: true, expanded: false }
];

export const SOCIAL_SECTION_IDS = new Set(SOCIAL_ANALYTICS_SECTIONS.map((section) => section.id));

export function isSocialSection(id) {
    return SOCIAL_SECTION_IDS.has(id);
}

export function enabledSocialSections(enabledBetas) {
    return SOCIAL_ANALYTICS_SECTIONS
        .filter((section) => !!enabledBetas?.[section.betaId])
        .map((section, index) => ({
            id: section.id,
            name: section.name,
            visible: true,
            expanded: false,
            order: 1000 + index
        }));
}

export function mergeSocialSections(baseSections, enabledBetas) {
    const enabled = enabledSocialSections(enabledBetas);
    const enabledIds = new Set(enabled.map((section) => section.id));
    const kept = (baseSections || []).filter((section) => !isSocialSection(section.id) || enabledIds.has(section.id));
    const seen = new Set(kept.map((section) => section.id));
    const extra = enabled.filter((section) => !seen.has(section.id));
    return [...kept, ...extra];
}

export function isSocialSectionVisible(sectionId, enabledBetas) {
    const def = SOCIAL_ANALYTICS_SECTIONS.find((section) => section.id === sectionId);
    if (!def) return true;
    return !!enabledBetas?.[def.betaId];
}
